import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getAddressUpdateIndicator} from '../../services/getAddressUpdateIndicator';
import {UseGetAddressUpdateIndicatorQueryParams} from './types';

export const useGetAddressUpdateIndicatorQuery = ({
	enabled,
	beneficiaryCode,
}: UseGetAddressUpdateIndicatorQueryParams = {}) =>
	useQuery({
		queryKey: [QUERY_KEYS.ADDRESS_UPDATE_INDICATOR, beneficiaryCode],
		queryFn: ({signal}) => getAddressUpdateIndicator({signal}),
		enabled: !!beneficiaryCode && enabled,
	});
